import { noop, get } from 'lodash-es';
import { put, call, takeLatest } from 'redux-saga/effects';

import {
	fetch_mf_payment_landing,
	initiate_mf_payment,
	cancel_mf_payment,
} from '../../../../apis/paymentV2/mf';
import {
	setActionLoaderTrue,
	setActionLoaderFalse,
} from '../../../reducers/actionLoader';
import {
	setActionError,
	resetActionError,
} from '../../../reducers/actionError';
import paymentService from '../../../../services/paymentService';
import { fetchMfPaymentLandingDetails, initiateMfPayment, cancelMfPayment, reinitiateMfPaymentFlow } from '../../../reducers/paymentV2/mf';
import {
    setPaymentDetails,
    setOrderCreationData,
    setMfInvestmentData,
    setBankDetails,
    setPaymentProduct,
    setPaymentFlow
} from '../../../reducers/paymentV2';
import { PAYMENT_PRODUCT_NAMES } from '../../../../constants/payment';
import { setLoader } from '../../../reducers/loader';
import { setError } from '../../../reducers/error';
import { genericErrorMessage } from '../../../../apis/common';
import { resetPaymentDetails } from '../../../reducers/paymentV2';



function* handleFetchMfPaymentLandingDetails({ payload }) {
	const { Api, params, sagaCallback = noop, screen = '', investType = '' } = payload;
	try {
		yield put(resetPaymentDetails());
		yield put(setLoader({ screen, isButtonLoading: true }));
		yield put(setActionLoaderTrue(fetchMfPaymentLandingDetails));
		const response = yield call(fetch_mf_payment_landing, {Api, params});
		const formatedCommonPaymentStructure = yield call(paymentService.formatMfPaymentResponse, {data: response, productName: PAYMENT_PRODUCT_NAMES.MF});
		const supportedBankList =  get(formatedCommonPaymentStructure, 'bank_list', {});
		const primaryBankDetails = paymentService.getPrimaryBankDetails(supportedBankList);
		yield put(setPaymentProduct(PAYMENT_PRODUCT_NAMES.MF));
		yield put(setPaymentFlow(investType));
        yield put(setBankDetails(primaryBankDetails));
		yield put(setMfInvestmentData({...params}));
		yield put(setPaymentDetails(formatedCommonPaymentStructure));
		yield call(sagaCallback);
	} catch(e) {
		console.log(e);
		yield put(setError({
			screen,
			isUpdateFailed: true,
			message: e.message || genericErrorMessage,
			err: e,
		}));
		yield put(setLoader({ screen, isButtonLoading: false }));
	} finally {
		yield put(setActionLoaderFalse(fetchMfPaymentLandingDetails));
	}
}

function* handleCancelMfPayment({ payload }) {
	const { Api, url, sagaCallback = noop } = payload;
	try {
		yield put(resetActionError(cancelMfPayment));
		yield put(setActionLoaderTrue(cancelMfPayment));
		const response = yield call(cancel_mf_payment, {Api, url});
		yield call(sagaCallback, response);
	} catch (error) {
		console.log('error while cancelling the order');
		yield put(
			setActionError({ isFetchFailed: true, actionName: cancelMfPayment }),
		);
	} finally {
		yield put(setActionLoaderFalse(cancelMfPayment));
	}
}

function* handleInitiateMfPayment({payload}) {
	const {
		Api,
		url,
		params,
		sagaCallback = noop,
		paymentType = '',
		androidPackageName = '',
	} = payload;
	try {
		yield put(resetActionError(initiateMfPayment));
		yield put(setActionLoaderTrue(initiateMfPayment));
		const response = yield call(initiate_mf_payment, {Api, url, params});
		const formatedMfOrderCreationData = yield call(paymentService.formateMfOrderCreationResponse, response);
		yield put(setOrderCreationData(formatedMfOrderCreationData));
		yield call(sagaCallback, response, paymentType, androidPackageName);
	} catch (error) {
		console.log('coming error while initiating the payment');
		yield put(
			setActionError({
				isFetchFailed: true,
				message: error.message,
				actionName: initiateMfPayment,
			}),
		);
	} finally {
		yield put(setActionLoaderFalse(initiateMfPayment));
	}
}

function* handleReinitiateMfPaymentFlow({payload}) {
	const { Api, params, sagaCallback = noop, screen = '', investType = '' } = payload;
	try {
		yield put(setActionLoaderTrue(fetchMfPaymentLandingDetails));
		const response = yield call(fetch_mf_payment_landing, {Api, params});
		const formatedCommonPaymentStructure = yield call(paymentService.formatMfPaymentResponse, {data: response, productName: PAYMENT_PRODUCT_NAMES.MF});
		yield put(setPaymentProduct(PAYMENT_PRODUCT_NAMES.MF));
		yield put(setPaymentFlow(investType));
		yield put(setMfInvestmentData({...params}));
		yield put(setPaymentDetails(formatedCommonPaymentStructure));
		yield call(sagaCallback);
	} catch(e) {
		console.log(e);
		yield put(setError({
			screen,
			isUpdateFailed: true,
			message: e.message || genericErrorMessage,
			err: e,
		}));
	} finally {
		yield put(setActionLoaderFalse(fetchMfPaymentLandingDetails));
	}
}

export default function* addFundsPaymentSaga() {
	yield takeLatest(fetchMfPaymentLandingDetails.toString(), handleFetchMfPaymentLandingDetails);
	yield takeLatest(initiateMfPayment.toString(), handleInitiateMfPayment);
	yield takeLatest(cancelMfPayment.toString(), handleCancelMfPayment);
	yield takeLatest(reinitiateMfPaymentFlow.toString(), handleReinitiateMfPaymentFlow )
}
